
<!--    <nav class="navbar navbar-expand-md navbar-blue d-flex justify-content-between" [ngStyle]="{'height': height + 'px'}">-->


      <ng-content></ng-content>






